import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Advertising Requirements\n          ")
], -1);
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm" }, "*If you would like to review the full recruitment policy please click here", -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "*All vacancies should be advertised in line with European Social Agreement and approvers are instructed to challenge this decision.", -1);
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = ["innerHTML"];
import { Input } from '@/form';
export default /*#__PURE__*/ _defineComponent({
    __name: 'advertisingRequirements',
    props: {
        formData: {},
        disableForm: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const recruitment = Input('Do you want the recruitment team to advertise the role? ', 'recruitment', 'text', props.disableForm, props.formData.recruitmentTeam);
        const advertise_salary = Input('Which wording would you like to use to advertise the salary? ', 'advertise_salary', 'text', props.disableForm, props.formData.advertise);
        const shortlist = Input('Do you want the recruitment team to shortlist the applications? ', 'shortlist', 'text', props.disableForm, props.formData.recruitmentShortlist);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(recruitment) }, null, 8, _hoisted_5),
                        _createTextVNode(),
                        _hoisted_6,
                        _createTextVNode(),
                        _hoisted_7,
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(advertise_salary) }, null, 8, _hoisted_8),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(shortlist) }, null, 8, _hoisted_9)
                    ])
                ])
            ]));
        };
    }
});
